import { FirstStepContainer } from "../components/FirstStepContainer";

export function HomePage() {
  return <FirstStepContainer />;
}
